/**
 * Policy and support pages every native creator website has. Drate provides and maintains each
 * one until the creator customizes it: their own page at the same address then replaces it, and
 * stops receiving Drate's updates. Platform administrators edit Drate's version in
 * /admin/templates.
 */
export const policyPages = [
  {
    id: "privacy",
    path: "/privacy",
    title: "Privacy policy",
    footerLabel: "Privacy",
    description: "What this website collects and how it is used.",
  },
  {
    id: "terms",
    path: "/terms",
    title: "Terms of service",
    footerLabel: "Terms",
    description: "The terms for using this website and its memberships.",
  },
  {
    id: "refunds",
    path: "/refunds",
    title: "Refund policy",
    footerLabel: "Refunds",
    description: "Cancellations, refunds and returns.",
  },
  {
    id: "faq",
    path: "/faq",
    title: "FAQ",
    footerLabel: "FAQ",
    description: "Answers to common questions about memberships and accounts.",
  },
  {
    id: "help",
    path: "/help",
    title: "Help center",
    footerLabel: "Help",
    description: "Help with joining, signing in, your account and your membership.",
  },
] as const;

export type PolicyPage = (typeof policyPages)[number];
export type PolicyPageId = PolicyPage["id"];
export const policyPageIds = policyPages.map((page) => page.id) as [
  PolicyPageId,
  ...PolicyPageId[],
];
export const policyPagePaths: readonly string[] = policyPages.map((page) => page.path);

export function policyPageForPath(path: string): PolicyPage | null {
  return policyPages.find((page) => page.path === path) ?? null;
}

export function policyPage(id: PolicyPageId): PolicyPage {
  return policyPages.find((page) => page.id === id)!;
}
